import React from 'react';
import './Banner.css';
import RetailerSearch from './../rsearch/RetailerSearch.js';
import MediaQuery from './../media-query/MediaQuery.js';

class Banner extends React.Component {
  render() {
    return(
      <div className="banner">
        <div><h2 className="banner-heading">Shop Indian Groceries</h2></div>
        <div><h4 className="banner-subheading">From your favorite neighborhood store</h4></div>
        <MediaQuery size="desktop">
          <RetailerSearch searchFunc={this.props.searchFunc}/>
        </MediaQuery>
      </div>
    );
  }
}

Banner.propTypes = {
  searchFunc: React.PropTypes.func.isRequired,
}


export default Banner



// WEBPACK FOOTER //
// ./src/components/home/Banner.js